"use client";

import { TreeConfig } from "../types";

interface ParentComponentMessageProps {
  treeConfig: TreeConfig;
}

export const ParentComponentMessage = ({ treeConfig }: ParentComponentMessageProps) => {
  if (!treeConfig.parentComponentMessage) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
      <p className="text-blue-800 font-medium mb-2">
        {treeConfig.parentComponentMessage.title}
      </p>
      <p className="text-blue-600 text-sm">
        {treeConfig.parentComponentMessage.description}
      </p>
    </div>
  );
};

